import React, { useEffect } from 'react'
import PCLNAnalytics from '@pcln/analytics'
import { SignInToastContent } from '@pcln/horizon-fly-components'
import { useToastManager } from '@pcln/horizon'

const SESSION_KEY = 'sign_in_toast_shown'

/**
 * One-time Express Deal signup promotion toast (AIR_LISTING_DEAL_MSG_SIGNUP). Must render under Horizon ToastProvider.
 */
export function useExpressDealSignInToast({ enabled, onSignInClick, onCreateAccountClick }) {
  const { add } = useToastManager()

  useEffect(() => {
    if (!enabled) return
    if (sessionStorage.getItem(SESSION_KEY)) return
    sessionStorage.setItem(SESSION_KEY, '1')
    add({
      title: 'Exclusive Flight Deals',
      description: 'Sign in or join VIP for free to get extra savings on Express Deals',
      data: {
        palette: 'neutral',
        emphasis: 'regular',
        contentNode: (
          <SignInToastContent
            onSignInClick={(e) => {
              PCLNAnalytics.log({
                category: 'Flight Listings',
                action: 'Sign In Toast',
                label: 'Sign In Button Click',
              })
              onSignInClick?.(e)
            }}
            onCreateAccountClick={(e) => {
              PCLNAnalytics.log({
                category: 'Flight Listings',
                action: 'Sign In Toast',
                label: 'Create Account Button Click',
              })
              onCreateAccountClick?.(e)
            }}
          />
        ),
      },
    })
    // Intentionally omit handler deps: sessionStorage ensures add() runs once; stable callbacks are unnecessary in Listings.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- see above
  }, [add, enabled])
}
